export default "__VITE_ASSET__GzP30MP___"